import { useMemo, useState } from 'react';
import { Stepper } from '@agrotoken-tech/ui';
import {
  SignUpFormProvider,
  useSignupFormContext,
} from '../context/useSignUpContext';
import { FirstStepForm } from './FirstStepForm';
import { SecondStepForm } from './SecondStepForm';
import { ThirdStepForm } from './ThirdStepForm';
import { SignupSummary } from './SignupSummary';
import { useTranslation } from '@bcba/react-hooks';

export const InnerSignUpForm = ({
  step,
  setStep,
}: {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { LeaveFormModal } = useSignupFormContext();
  const { t } = useTranslation();
  const isOnFirsStep = step === 1;
  const isOnSecondStep = step === 2;
  const isOnThirdStep = step === 3;
  const isOnSummary = step === 4;

  const stepperJSX = useMemo(
    () => (
      <Stepper
        options={[
          {
            label: t('businessSignUp.firstStep.stepIndicator'),
          },
          {
            label: t('businessSignUp.secondStep.stepIndicator'),
          },
          {
            label: t('businessSignUp.thirdStep.stepIndicator'),
          },
        ]}
        onNavigate={() => {}}
        currentStep={step}
        setStep={setStep}
      />
    ),
    [step],
  );

  return (
    <>
      {isOnFirsStep ? (
        <FirstStepForm setStep={setStep} stepperJSX={stepperJSX} />
      ) : null}
      {isOnSecondStep ? (
        <SecondStepForm setStep={setStep} stepperJSX={stepperJSX} />
      ) : null}
      {isOnThirdStep ? (
        <ThirdStepForm setStep={setStep} stepperJSX={stepperJSX} />
      ) : null}
      {isOnSummary ? <SignupSummary /> : null}
      {LeaveFormModal}
    </>
  );
};

export const SignUpForm = () => {
  const [step, setStep] = useState(1);

  return (
    <SignUpFormProvider step={step}>
      <InnerSignUpForm step={step} setStep={setStep} />
    </SignUpFormProvider>
  );
};
